import { createFrontendModule } from '@backstage/frontend-plugin-api';

import {
  LayoutExtension,
  SidebarExtension,
  SignInPageExtension,
} from './extensions';

export const ipenAppModule = createFrontendModule({
  extensions: [
    LayoutExtension,
    SidebarExtension,
    SignInPageExtension,
  ],
  pluginId: 'app',
});
